import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { openAuthModal } from '../../store/slices/authSlice';
import Button from '../Button/Button';
import bgImage from '../../assets/images/bg.png';
import lnImage from '../../assets/images/Lines.svg';
import mobi from '../../assets/images/mobile.png';
import apple from '../../assets/logos/applelogo.svg';
import google from '../../assets/logos/googleplaylogo.svg';
import './HeroSection.css';

const HeroSection = () => {
  const dispatch = useDispatch();
  const [scrollY, setScrollY] = useState(0);

  const handleStartJourney = () => {
    dispatch(openAuthModal('signup'));
  };

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const showDummy = scrollY >= 100;

  const dummyProgress = Math.min(
  Math.max((scrollY - 100) / 300, 0),
  1
);

  return (
    <section className="hero-section">
      {/* HERO CONTENT */}
      <div
  className={`hero-content ${showDummy ? 'hide' : ''}`}
  style={{
    opacity: 1 - dummyProgress,
    transform: `translateY(${-dummyProgress * 40}px)`
  }}
>
        <div className="hero-background-layer">
          <img
            src={bgImage}
            alt="Students planning their future"
            className="hero-background-image"
          />
        </div>

        <div className="hero-container">
          <div className="hero-text-container">
            <h1 className="hero-heading">
              A Step That Shapes<br />
              Your Future.
            </h1>
            <p className="hero-subheading">
              Discover your ideal career and education path with the perfect blend of experienced
              counsellors and intelligent AI support—personalized just for you.
            </p>
            <Button onClick={handleStartJourney} variant="hero">
              START YOUR JOURNEY
            </Button>
          </div>
        </div>

            <section className="hero-bottom1">
             <p>
              If only finding a career was
              as simple as clicking a button
            </p>
            </section>
             <section className="hero-bottom">
      <div className='mouse-icon'>
         <div className='mouse-scroll'></div>
        </div>
      </section>


      </div>

      {/* DUMMY CONTENT */}
   <div
  className="dummy-content"
  style={{
    opacity: dummyProgress,
    transform: `translateY(${40 - dummyProgress * 40}px)`
  }}
>
   <div className="service-curve-line23">
      <svg
        width="568"
        height="590"
        viewBox="0 0 568 583"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.7"
          d="M252.209 -200.254C251.382 -198.433 250.555 -196.611 249.728 -194.79C283.285 -179.56 313.743 -163.187 344.117 -142.696C440.504 -81.196 520.615 37.0837 479.321 152.548C442.061 265.859 309.164 329.153 194.95 300.312C169.759 294.29 143.677 286.564 128.329 266.516C112.276 244.891 127.834 217.166 144.978 199.455C180.941 162.842 228.375 139.667 276.806 123.024C366.948 90.5735 510.233 88.0165 537.27 201.033C539.212 208.242 540.742 215.913 541.826 224.066C571.187 439.694 325.676 571.769 135.103 558.68C99.2727 555.841 63.0919 547.448 32.1298 528.969C63.0579 547.507 99.2426 555.969 135.088 558.869C325.679 572.225 571.921 440.742 543.106 223.897C542.034 215.69 540.513 207.958 538.575 200.683C511.451 86.2942 366.608 88.5823 276.104 120.91C227.354 137.52 179.681 160.527 143.004 197.593C125.666 215.379 108.65 244.537 125.906 268.226C142.301 289.624 168.778 297.205 194.24 303.455C309.656 333.019 445.007 269.561 483.519 153.981C526.183 36.0135 444.408 -85.0584 347.289 -147.364C316.655 -168.176 285.979 -184.797 252.209 -200.254Z"
        />

        <path
          d="M319.961 -211.115C319.774 -210.839 319.587 -210.563 319.401 -210.287C349.301 -189.99 376.131 -169.061 402.173 -144.331C487.579 -67.3116 548.492 64.0278 488.054 172.606C431.997 279.591 288.719 320.035 180.197 271.814C155.673 261.209 130.412 249.111 118.197 224.989C105.888 199.269 128.363 173.484 148.633 159.229C192.135 128.954 245.08 114.457 297.192 107.7C349.489 101.66 404.532 103.854 452.694 126.688C501.901 148.413 531.208 201.696 528.563 255.275C502.493 450.74 274.872 532.519 98.4276 538.459C63.7321 537.247 26.5142 531.768 -1.14042 509.175C26.5038 531.782 63.7261 537.281 98.4263 538.509C274.895 532.618 502.614 451.087 528.877 255.279C531.565 201.628 502.183 148.127 452.865 126.338C404.602 103.432 349.496 101.219 297.136 107.239C244.958 113.984 191.969 128.449 148.316 158.792C128.01 173.06 105.204 199.058 117.671 225.227C130.049 249.655 155.393 261.727 179.962 272.382C288.698 320.76 432.419 280.33 488.744 172.976C549.475 63.9894 488.337 -67.8544 402.828 -145.019C376.751 -169.805 349.891 -190.778 319.961 -211.115Z"
        />
      </svg>
    </div>
      <div className='inner-sec'>
          <div className='inner-sec-desc'>
            <p>
              If only finding a career was
              as simple as clicking a button
            </p>
           <img src={mobi} alt="Mobile Illustration" className='mobile-illustration'/>
           <div className='appstore-logos'>
            <img src={apple} alt="" srcset="" className='apple' />
            <img src={google} alt="" srcset="" className='google'/>
           </div>
           <div className='card-Cont'>
            <div className='indCard'>
              <h2>200+</h2>
              <p>Industry Experts</p>
            </div>
            <div className='indCard'>
              <h2>100+</h2>
              <p>University Partners</p>
            </div>
            <div className='indCard'>
              <h2>999+</h2>
              <p>Company Partners</p>
            </div>
            <div className='indCard'>
              <h2>2.5M</h2>
              <p>Active Jobs</p>
            </div>
           </div>
          </div>
        
      </div>

  
      </div>
      
    </section>
  );
};

export default HeroSection;
